export const cssStyles = `
.contract-body {
  width: 100%;
  font-family: Arial, sans-serif;
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.contract-td {
  padding: 4px;
  border: 1px solid black;
}

.contract-table-header{
  margin-bottom: 2px;
  margin-top: 0px;
  text-align: left;
}

.contract-parties {
  width: 100%;
  margin-top: 20px;
}

.contract-align-center{
    text-align: center;
}

.contract-border-thick {
  border-left: 2px solid black;
}

.contract-table{
  border-collapse: collapse;
  width: 100%;
}

.contract-third-space{
  width: 33%;
}

.contract-half-space{
  width: 50%;
}

.contract-quater-space{
  width: 25%;
}

.contract-three-quater-space{
  width: 75%;
}

.contract-half-quater-space{
    width: 12.5%;
}

.contract-helper-text {
  font-size: 10px;
  margin-bottom: -10px;
  margin-top: -2px;
}

.contract-small-margin-top{
  margin-top: 5px;
}

.contract-no-margin-top{
  margin-top: -20px;
}

.margin-top-large{
  margin-top: 40px;
}

.page-break{
   page-break-after: always;
}

.contract-min-width{
  min-width: 100px;
}

p {
  font-size: 12px;
  min-height: 12px;
}

.black-box {
  background-color: black !important;
  width: 20px;
  height: 20px;
  margin-left: 20px;
}

.pdf-checkbox {
  display: inline-block;
  width: 11px;
  height: 11px;
  border: 1px solid black;
  text-align: center;
  line-height: 11px;
  font-size: 10px;
  font-weight: bold;
  vertical-align: middle;
}

.pdf-checkbox-gap {
  margin-left: 16px;
}

.contract-section-th {
  padding-top: 6px;
  font-size: 14px;
}

.contract-insurance-p {
  margin-top: 6px;
  margin-bottom: 4px;
  font-size: 13px;
}

.contract-td-noborder {
  border: none;
  padding: 0;
}

.contract-section-spacer {
  height: 16px;
}

.contract-p-margin {
  margin: 4px 0;
  font-size: 13px;
}

.contract-quarter-width {
  width: 25%;
}

.contract-care-table {
  border-collapse: collapse;
  width: 35%;
}

.contract-care-label {
  white-space: nowrap;
}

.contract-checkbox-cell {
  padding: 2px 8px;
  white-space: nowrap;
}

/* Product box - bigger so the product stands out more than service/insurance */
.contract-product-cell {
  padding: 8px;
}

.contract-product-label {
  font-size: 12px;
}

.contract-product-value {
  font-size: 14px;
  font-weight: bold;
}

/* Service/insurance rows - smaller than the product box */
.contract-service-header {
  font-size: 14px;
}

.contract-service-row {
  margin: 6px 0;
  font-size: 13px;
}

.contract-service-value {
  font-size: 13px;
  margin: 4px 0;
}

.contract-service-value-after-label {
  margin-top: 14px;
}

.contract-checkbox-checked {
  width: 16px;
  height: 16px;
  border: 8px solid black;
  box-sizing: border-box;
}

.contract-checkbox-empty {
  width: 16px;
  height: 16px;
  border: 1px solid black;
}

.contract-product-table-fr td:nth-child(1) {
  width: 60%;
}

.contract-product-table-fr td:nth-child(2) {
  width: 22%;
}

.contract-product-table-fr td:nth-child(3) {
  width: 18%;
}

.contract-product-table-de td:nth-child(1) {
  width: 50%;
}

.contract-product-table-de td:nth-child(2) {
  width: 30%;
}

.contract-product-table-de td:nth-child(3) {
  width: 20%;
}

.contract-product-table-se td:nth-child(1),
.contract-product-table-no td:nth-child(1),
.contract-product-table-dk td:nth-child(1) {
  width: 60%;
}

.contract-product-table-se td:nth-child(2),
.contract-product-table-no td:nth-child(2),
.contract-product-table-dk td:nth-child(2) {
  width: 23%;
}

.contract-product-table-se td:nth-child(3),
.contract-product-table-no td:nth-child(3),
.contract-product-table-dk td:nth-child(3) {
  width: 17%;
}

.contract-annex-note {
  margin: 0;
  align-self: center;
}

`;
